import { defaultsDeep } from "lodash";
import { DeepNullableObj, Event } from "../types";
import { MockFn, createMock } from "./index";
import mockAccount from "./mockAccount";
import mockCareprovider from "./mockCareprovider";
import mockCareseeker from "./mockCareseeker";
import mockEventContext from "./mockEventContext";

const mockEvent: MockFn<Partial<DeepNullableObj<Event>>> = (args) =>
  defaultsDeep(
    args,
    createMock(
      "Event",
      args,
      (shallow): DeepNullableObj<Event> => ({
        __typename: "Event",
        account: mockAccount({ ...shallow("Account") }),
        careprovider: mockCareprovider({ ...shallow("Careprovider") }),
        careseeker: mockCareseeker({ ...shallow("Careseeker") }),
        context: mockEventContext({ ...shallow("EventContext") }),
        last_seens: null,
        origin: null,
        patient_id: null,
        seen_by_recipient: null,
        seen_by_recipient_timestamp: null,
        subject_account: {
          __typename: "Account",
          academic_title: null,
          account_type: null,
          first_name: null,
          gender: null,
          id: null,
          last_name: null,
          title: null,
        },
        timestamp: null,
        type: null,
        user_id: null,
      }),
    ),
  );

export default mockEvent;
